import { useCallback } from 'react';
import { isType } from 'variant';
import type { PlatformType } from '@wix/cli-app-definitions';
import { useProjectModel } from '../../model.js';

export function usePlatform() {
  const { model } = useProjectModel();

  const isPlatformExists = useCallback(
    (platformType: PlatformType) =>
      model.components.some((component) =>
        component.platforms.some(isType(platformType.type))
      ),
    [model.components]
  );

  const hasSinglePlatform = useCallback(
    (platformType: PlatformType) =>
      model.components.every(
        (component) =>
          component.platforms.some(isType(platformType.type)) ||
          component.platforms.length === 0
      ),
    [model.components]
  );

  return {
    isPlatformExists,
    hasSinglePlatform,
  };
}
